import React from "react";
import Chart from "react-apexcharts";

export default function SpentBudgetChart({data}) {
  // const data = [
  //   {
  //     name: "North Macedonia",
  //     quantity: 17.5
  //   },
  //   {
  //     name: "Serbia",
  //     quantity: 13.5
  //   },
  //   {
  //     name: "Bosnia and Herzegovina",
  //     quantity: 25
  //   },
  //   {
  //     name: "Kosovo",
  //     quantity: 23.3
  //   },
  //   {
  //     name: "Montenegro",
  //     quantity: 20.7
  //   }
  // ];

  const totalBudget = data.reduce((sum, item) => sum + item.totalSpentBudget, 0);
  const names = data.map(n => n?.countryName);
  const quantities = data.map(
    (item) => parseFloat(((item.totalSpentBudget / totalBudget) * 100).toFixed(1)) // Round to 2 decimal places
  );


  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#9DBCEC", "#CEDDF6", "#0B57D0", "#3C79D9", "#6D9AE3"],
    chart: {
      type: 'pie'
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px',
        colors: ['#000'],
        fontWeight: 'normal'
      },
      dropShadow: {
        enabled: false 
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -20,
          },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val.toLocaleString()}%`;
        }
      }
    },
    responsive: [
      {
        breakpoint: 1400,
        options: {
          chart: {
            width: "300",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: "230",
          },
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
    ]
  };

  const series = quantities;

  return (
    <Chart
      options={options}
      series={series}
      type="pie"
      width="380"
    />
  );
}